import { FormGroup, FormArray } from "@angular/forms";
import * as moment from "moment";
import { RoomConfigurationItem } from "../home/search-box/categories/hotels/roomConfigurationItem";
import { roomSearchConfigurationItem } from "../home/search-box/categories/hotels/roomSearchConfigurationItem";


import { environment } from "environments/environment";

// eslint-disable-next-line max-len
export function searchPayload(categoria: string, dateRange: any, form: FormGroup, destiny: string, origin: string = "", extras: any = {}, marketId?:number, nationality?: string, agencyId?:number, country?: string, hotelId?: any, type?:any, idActivity?:number, categoryId?:number, countryCode?:string, _longDestination?:string) {

  interface payload { [key: string]: any; }
  let  _payload: payload = {};


  _payload = {
    providersId: null,
    categoriesId: [1],
    others: {
      maxRequestTimeOnSeconds: environment.maxRequestTimeOnSeconds,
      minNumResults: environment.minNumResults,
      maxNumResultsPerAdapter: environment.maxNumResultsPerAdapter,
    },
  };

  switch (categoria) {
    case 'HOTELS':
        if(destiny !== "") {
          _payload.destination = destiny;
        };
        if(hotelId !== undefined) {
          _payload.hotels = [hotelId];
          delete _payload.destination;
        }
        _payload.categoriesId = [1];
        _payload.origin = origin;
        _payload.city = form.value['destination']['city_name'],
        _payload.priceFrom = 0,
        _payload.priceTo = 20000,
        // eslint-disable-next-line max-len
        _payload.arrivalDate = dateRange.start.$d ? moment(dateRange.start.$d.toString().split(",")[0]).format("YYYY-MM-DD") : moment(form.value.arrivalDateDepartureDate.start).format('YYYY-MM-DD'),
        // eslint-disable-next-line max-len
        _payload.departureDate = dateRange.end.$d ? moment(dateRange.end.$d.toString().split(",")[0]).format("YYYY-MM-DD") : moment(form.value.arrivalDateDepartureDate.end).format('YYYY-MM-DD'),
        _payload.qtyProduct = +form.value['qtyProduct'],
        _payload.qtyPax = +form.value['qtyAdults'],
        _payload.qtyPax = _getAdultsChildrenQty(categoria, 'qtyAdults', form);
        _payload.nationality = nationality ? nationality : '';
        _payload.agencyId = agencyId;
        _payload.agencyCountry = country;
        _payload.page = 1;
        _payload.per_page = 10;
        _payload.country = country;
        _payload.others.hotels = {
            roomConfiguration: _getRoomDist(form),
      };
      break;
      case "TOURS":
      _payload.categoriesId = [categoryId];
      _payload.origin = origin,
      _payload.destination = destiny,
      _payload.agencyId = agencyId;
      _payload.nationality = countryCode;//"AR"
      _payload.city = _longDestination,//Miami
      _payload.priceFrom = 0,
      _payload.priceTo = 20000,
      _payload.market = 2;
      // _payload.type_tour = 26;
      // eslint-disable-next-line max-len
      _payload.arrivalDate = dateRange.start.$d ? moment(dateRange.start.$d.toString().split(",")[0]).format("YYYY-MM-DD") : dateRange.start,
      // eslint-disable-next-line max-len
      _payload.departureDate = dateRange.end.$d ? moment(dateRange.end.$d.toString().split(",")[0]).format("YYYY-MM-DD") : dateRange.end,

      _payload.others.tours = {
        adults: +form.value["qtyAdults"],
        children: form.value["childsage"].map((obj) => obj.age) || [null],
      };
      break;

    case "INSURANCE":

      const paxes = form.value.paxes;
      const hasAnyPreExistingCondition = paxes.some((pax: any) => {

        if(!pax.addons || pax.addons.length === 0) {
          return false;
        }

        return pax.addons.includes('hasPreExistingCondition');
      });

      const HasAnyPregnant = paxes.some((pax: any) => {

        if(!pax.addons || pax.addons.length === 0) {
          return false;
        }

        return pax.addons.includes('isPregnant');
      });

      const HasAnyOnTrip = paxes.some((pax: any) => {

        if(!pax.addons || pax.addons.length === 0) {
          return false;
        }

        return pax.addons.includes('isOnTrip');
      });

      _payload.categoriesId = [10];
      _payload.dateBegin = dateRange.start.$d ? moment(dateRange.start.$d.toString().split(",")[0]).format("YYYY-MM-DD") : dateRange.start,
      _payload.dateEnd = dateRange.end.$d ? moment(dateRange.end.$d.toString().split(",")[0]).format("YYYY-MM-DD") : dateRange.end,
      _payload.market = 2,
      _payload.contact = {
        wsp_phone_contact: form.value?.wsp_phone_contact,
        email_contact: form.value?.email_contact
      }
      _payload.insurances = {
        origin: form.value.origin,
        destination: form.value.destination,
        tripType: form.value.serviceType,
        paxList: [
          {
            qtyPax: paxes.length,
            paxAges: paxes.map((c: any) => {return c.age}),
            hasPreExistingCondition: hasAnyPreExistingCondition,
            isPregnant: HasAnyPregnant,
            isOnTrip: HasAnyOnTrip,
            pregnancyWeeks: null
          }
        ]
      };
      break;
    case "PTHEME":
      _payload.categoriesId = [4];
      // _payload.type_tour = idActivity;
      _payload.others.tickets = {
        adults: parseInt(form.value["qtyAdults"]),
        children: form.value["childsage"].map((obj) => obj.age) || [null],
      };
      break;
    case "DISNEY":
      let adults = 0;
      form.value["room"].forEach((room) => {
        adults += Number.parseInt(room["qtyAdults"]);
      });
      const childs = [];

      form.value["room"].forEach((room) => {
        room["childsage"].forEach((age) => {
          childs.push(age["age"]);
        });
      });
      _payload.qtyPax = adults;
      _payload.qtyAdults = adults;
      _payload.providersId = ["c38caa90-f019-11e7-b791-2702c92c19de"];
      _payload.categoriesId = [12];
      _payload.disneyCategory = ["ALL"];
      _payload.hotelId = 0;
      _payload.searchId = null;
      _payload.rooms = {
        qtyPax: adults,
        adults: adults,
        childs: childs,
      };
      _payload.others = {
        minNumResults: 5,
        orderColumn: "title",
        orderType: "ASC",
        roomIntelligence: false,
        serialized: true,
      };
      break;
   case "RENT-A-CAR":
        const destination = form.value?.destination ? form.value.destination : form.value.origin;
        const typeDestination = form.value.returnDestinations ? form.value.typeOrigin : form.value.typeDestination;
        _payload.providersId = [];
        _payload.categoriesId = [2];
        _payload.agencyId = agencyId;

        const originPickupLocation = type.origin === 'airport' ? (form.value.origin.data?.iata || form.value.origin?.iata) : (form.value.origin.data?.city_iata || form.value.origin.data?.city_iata_code ||  form.value.origin?.city_iata || form.value.origin?.city_iata_code || form.value.origin?.data);
        const destinationDropoff = type.destination === '' ? type.origin : type.destination;
        const destinationDropoffLocation = destinationDropoff === 'airport' ? (destination.data?.iata || destination?.iata) : (destination.data?.city_iata || destination.data?.city_iata_code || destination.city_iata || destination.city_iata_code || form.value.origin?.data);

        // Usar la función unificada
        _payload.arrivalDate = formatDate(dateRange.start);
        _payload.departureDate = formatDate(dateRange.end);
        _payload.nationality = nationality;

        _payload.others.carRental = {
          ageDriver: form.value["age"],
          lang: 'ESP',
          CountryOfResidence: 'ES',
          pickupLocation: {
            origin: originPickupLocation,
            type: type.origin,
            pickupDate: formatDate(dateRange.start), // Usar misma función
            pickupTime: form.value['hourOrigin'] + ':00'
          },
          dropoffLocation: {
            destination: destinationDropoffLocation,
            type: destinationDropoff,
            dropoffDate: formatDate(dateRange.end), // Usar misma función
            dropoffTime: form.value['hourDestination'] + ':00'
          }
        };
  break;
    case "BOATS":
      const boatsRoom = form.value["room"][0];
      _payload = {
        categoriesId: [3],
        destination: destiny,
        arrivalDate: formatDate(dateRange.start),
        departureDate: formatDate(dateRange.end),
        positiveRange: extras.dateFlex ?? 0,
        negativeRange: extras.dateFlex ?? 0,
        agencyId: agencyId,
        boats: {
          adults: +boatsRoom.qtyAdults,
          children: boatsRoom.childsage.map((child) => +child.age),
        },
      };
      break;
    case "PACKAGES":
      _payload.categoriesId = [7];
      _payload.qtyPax = _getAdultsChildrenQty(categoria, "qtyAdults", form);
      break;
    default:
      break;
  }
  return _payload;
}

export function _getAdultsChildrenQty(categoria: string, key: string, form: FormGroup) {
  let qtyPax: any;
  let qty: any;
  switch (categoria) {
    case "HOTELS":
      key === "qtyAdults"
        ? form.value["room"].map((obj) => obj.qtyAdults).forEach((element) => (qty += +element))
        : form.value["room"].map((obj) => obj.qtyChilds).forEach((element) => (qty += +element));
      qtyPax = qty;
      break;
    case "PACKAGES":
      key === "qtyAdults"
        ? form.value["room"].map((obj) => obj.qtyAdults).forEach((element) => (qty += +element))
        : form.value["room"].map((obj) => obj.qtyChilds).forEach((element) => (qty += +element));
      qtyPax = qty;
      break;
    case "INSURANCE":
      key === "qtyAdults"
      ? qty = (form.value['firstqtyAdults'] + form.value['firstqtyChilds'])
      : qty = [25];
      qtyPax = qty;
      break;

    default:
      const ages = [];
      if (key === "adultsage") {
        let cont = 0;
        for (let i = 0; i < form.value.room.length; i++) {
          const adultsage = form.value.room[i].adultsage;
          for (let j = 0; j < adultsage.length; j++) {
            ages.push(adultsage[j].age);
            cont++;
          }
        }
      } else {
        let cont = 0;
        for (let i = 0; i < form.value.room.length; i++) {
          const childsage = form.value.room[i].childsage;
          for (let j = 0; j < childsage.length; j++) {
            ages.push(childsage[j].age);
            cont++;
          }
        }
      }
      qtyPax = ages;
      break;
  }

  return qtyPax;
}

export function _getRoomDist(form?: FormGroup) {
  const roomDist = [];
  const rooms = form.value.room;
  for (let i = 0; i < rooms.length; i++) {
    const people = [];
    const dist: roomSearchConfigurationItem = {
      adults: 0,
      children: []
    };
    const adults = rooms[i].qtyAdults;
    const children = rooms[i].childsage;
    for (let j = 0; j < children.length; j++) {
      people.push(children[j].age);
    }
    dist.adults = adults;
    dist.children = people;
    roomDist.push(dist);
  }
  return roomDist;
}

export function getPayload(item: any) {
  const itemPayload = item.payloadUpdate ? item.payloadUpdate.products[0] : item.payload ? item.payload : null;
  let payload;
  switch (item.categoryName) {
    case "INSURANCE":
      payload = {
        products: [
          {
            providersId: item.providerId,
            nameAdapter: item.nameAdapter,
            categoryId: itemPayload.categoryId,
            productId: item.idProduct,
            productName: item.title,
            origin: itemPayload.origin ? itemPayload.origin : null,
            destination: itemPayload.destination,
            priceFrom: itemPayload.priceFrom,
            priceTo: itemPayload.priceTo,
            arrivalDate: item.arrivalDate,
            departureDate: item.departureDate,
            others: getPaxListWithFormat(item.payload.others, item.categoryName, item),
          },
        ],
      };
      break;
    case "PTHEMES":
      payload = {
        products: [
          {
            providersId: item.providerId,
            nameAdapter: itemPayload.nameAdapter,
            categoryId: itemPayload.categoryId,
            productId: itemPayload.productId,
            productName: itemPayload.productName,
            destination: itemPayload.destination,
            priceFrom: itemPayload.priceFrom,
            priceTo: itemPayload.priceTo,
            arrivalDate: item.arrivalDate,
            departureDate: item.departureDate,
            others: getPaxListWithFormat(itemPayload.others, item.categoryName, item),
          },
        ],
      };
      break;
    default:
      payload = getPayloadWithStandardFormat(item, itemPayload);
      break;
  }

  return payload;
}
export function getPayloadWithStandardFormat(item: any, itemPayload: any): any {
  return {
    products: [
      {
        providersId: item.providerId,
        nameAdapter: itemPayload.nameAdapter,
        categoryId: itemPayload.categoryId,
        productId: itemPayload.productId,
        productName: itemPayload.productName,
        origin: itemPayload.origin ? itemPayload.origin : null,
        destination: itemPayload.destination,
        priceFrom: itemPayload.priceFrom,
        priceTo: itemPayload.priceTo,
        arrivalDate: item.arrivalDate,
        departureDate: item.departureDate,
        qtyProduct: itemPayload.qtyProduct,
        qtyPax: itemPayload.qtyPax ? itemPayload.qtyPax : item.maxPax,
        others: getPaxListWithFormat(itemPayload.others, item.categoryName, item),
      },
    ],
  };
}
export function getPaxListWithFormat(others: any, category: string, item: any): any {
  let paxList;

  switch (category) {
    case "HOTELS":
      let child = 0;
      const ages = [];
      const agesAdult = [];
      const roomDist = [];
      others.hotels.roomConfiguration.forEach((room, index) => {
        child += room.children.length;
        const _room = [];
        for (let i = 0; i < Number.parseInt(room.adults); i++) {
          agesAdult.push(21);
          _room.push(21);
        }
        room.children.forEach((age) => {
          ages.push(Number.parseInt(age));
          _room.push(Number.parseInt(age));
        });
        roomDist.push(_room);
      });
      paxList = {
        child: child,
        ages: { int: ages },
        agesAdult: { int: agesAdult },
        roomDist: roomDist,
      };
      break;
    case "PTHEMES":
      paxList = {
        maxRequestTimeOnSeconds: 20,
        minNumResults: 3,
        maxNumResultsPerAdapter: "",
        tickets: {
          adults: item.paxAdults,
          children: others.ages.int,
        },
      };
      break;
    case "INSURANCE":
      paxList = {
        serialized: false,
        maxRequestTimeOnSeconds: others.maxRequestTimeOnSeconds,
        minNumResults: others.minNumResults,
        insurance: {
          adults: others.insurance.adults,
          children: others.insurance.children,
        },
        orderColumn: "title",
        orderType: "ASC",
      };
      break;
    case "TOURS":
      paxList = others;
      break;
    case "RENT-A-CAR":
      paxList = {
        carRental: {
          pickupTime: others.carRental.pickupTime,
          dropoffTime: others.carRental.dropoffTime,
          pickupLocation: {
            id: others.carRental.pickupLocation.id,
            type: others.carRental.pickupLocation.type,
            address: others.carRental.pickupLocation.address,
            providerId: others.carRental.pickupLocation.providerId,
            nameAdapter: others.carRental.pickupLocation.nameAdapter,
          },
          dropoffLocation: {
            id: others.carRental.dropoffLocation.id,
            type: others.carRental.dropoffLocation.type,
            address: others.carRental.dropoffLocation.address,
            providerId: others.carRental.dropoffLocation.providerId,
            nameAdapter: others.carRental.dropoffLocation.nameAdapter,
          },
        },
      };
      break;
    default:
      break;
  }

  return paxList;
}


// Función helper para formatear fecha desde cualquier formato
function formatDate(dateInput: any): string {
  if (!dateInput) return '';

  // Caso 1: Es un objeto con propiedad $d (de ngx-daterangepicker)
  if (dateInput.$d) {
    return moment(dateInput.$d).format('YYYY-MM-DD');
  }

  // Caso 2: Es un objeto Date
  if (dateInput instanceof Date) {
    return moment(dateInput).format('YYYY-MM-DD');
  }

  // Caso 3: Es un string de fecha
  if (typeof dateInput === 'string') {
    // Si ya tiene formato YYYY-MM-DD, devolverlo directo
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateInput)) {
      return dateInput;
    }
    // Si es otro formato, convertirlo
    return moment(dateInput).format('YYYY-MM-DD');
  }

  // Caso 4: Es un objeto moment
  if (moment.isMoment(dateInput)) {
    return dateInput.format('YYYY-MM-DD');
  }

  return '';
}
